/* eslint-disable camelcase */
import React from "react";
import { useRouter } from "next/router";
import {
  Button,
  RadioGroup,
  Switch,
  TextInput,
} from "@aqar-app/aqar-design-system";
import useForm from "../../hooks/useForm";
import CardContainer from "../../components/cardContainer/cardContainer";
import FieldError from "../../components/field-error/FieldError";
import SEO from "../../components/seo/SEO";
import styles from "./buildingCalculator.module.scss";
import { ConditionalWrapper } from "../../lib/helpers";
import { STATIC_PAGES_META } from "../../lib/metaDataHelpers";
import { InitialResolver } from "@/lib/use.middlewares";

const FLOORS_TYPE_OPTIONS = [
  { label: "دور واحد", value: "one_floor", className: styles.radioBtn },
  { label: "دورين", value: "two_floors", className: styles.radioBtn },
  {
    label: "دورين مع ملحق",
    value: "two_floors_with_roof",
    className: styles.radioBtn,
  },
];

const verifyListingFieldsValidator = (values) => {
  const errors = {};

  const { land_area, floors_type, basement, basement_area } = values;
  if (!land_area || land_area < 200 || land_area > 2500) {
    errors.land_area = "الرجاء إدخال مساحة أرض صحيحة بين ٢٠٠م و ٢٥٠٠م.";
  }

  if (!floors_type) {
    errors.floors_type = "الرجاء  اختيار عدد الأدوار.";
  }

  if (basement && !basement_area) {
    errors.basement_area = "الرجاء  إدخال مساحة القبو.";
  }

  return errors;
};

const BuildingCalculator = () => {
  const router = useRouter();
  const { iframe } = router.query;
  const { values, errors, handleChange, handleSubmit } = useForm(
    // eslint-disable-next-line no-use-before-define
    submit,
    verifyListingFieldsValidator,
  );

  const isFieldInvalid = (field) => {
    return !!errors[field];
  };

  const getFieldError = (field) => {
    return errors[field];
  };

  function submit() {
    delete values.basement;
    router.push({
      pathname: "/تكلفة-البناء",
      query: JSON.parse(
        JSON.stringify({ iframe: router.query.iframe, ...values }),
      ),
    });
  }

  return (
    <>
      <SEO {...STATIC_PAGES_META.buildingCalculator} />
      <ConditionalWrapper
        condition={iframe === "1"}
        wrapper={(children) => (
          <div className={styles.buildingCalculatorCard}>{children}</div>
        )}
        elseWrapper={(children) => {
          return (
            <CardContainer
              cardClassName={styles.buildingCalculatorCard}
              title="حاسبة البناء"
            >
              {children}
            </CardContainer>
          );
        }}
      >
        <div>
          <div className={styles.label}>مساحة الأرض</div>
          <div>
            <TextInput
              name="land_area"
              placeholder="مساحة الأرض"
              value={values.land_area || ""}
              type="number"
              invalid={isFieldInvalid("land_area")}
              onChange={handleChange}
              onPressEnter={handleSubmit}
            />
            {isFieldInvalid("land_area") && (
              <FieldError text={getFieldError("land_area")} />
            )}
          </div>
          <div className={styles.label}>عدد الأدوار</div>
          <div>
            <RadioGroup
              key={values.floors_type}
              className={styles.radioBtnWrapper}
              name="floors_type"
              onChange={(evt, val) => {
                evt.target.value = val;
                handleChange(evt);
              }}
              defaultValue={values.floors_type || ""}
              options={FLOORS_TYPE_OPTIONS}
            />
            {isFieldInvalid("floors_type") && (
              <FieldError text={getFieldError("floors_type")} />
            )}
          </div>
          <div className={styles.content}>
            <Switch
              defaultChecked={!!values.basement}
              onChange={(status) => {
                handleChange(undefined, {
                  basement: status || undefined,
                  basement_area: undefined,
                });
              }}
            />
            <div className={styles.title}>القبو</div>
          </div>
          <div style={{ visibility: values.basement ? "" : "hidden" }}>
            <TextInput
              name="basement_area"
              value={values.basement_area || ""}
              invalid={isFieldInvalid("basement_area")}
              onChange={handleChange}
              onPressEnter={handleSubmit}
              placeholder="مساحة القبو"
            />
            {isFieldInvalid("basement_area") && (
              <FieldError text={getFieldError("basement_area")} />
            )}
          </div>
          <div className={styles.actions}>
            <Button
              id="calculate-btn"
              className={styles.calculateBtn}
              contentClassName={styles.content}
              onClick={handleSubmit}
              label="احسب التكلفة"
              priority="primary"
              size="x-small"
            />
          </div>
        </div>
      </ConditionalWrapper>
    </>
  );
};

export default BuildingCalculator;
BuildingCalculator.getInitialProps = InitialResolver();
BuildingCalculator.propTypes = {};

BuildingCalculator.defaultProps = {};
